import { useEffect } from "react";

const SCRIPT_ID = "wnbf-jsonld";

/**
 * Inject (or refresh) a <script type="application/ld+json"> block in the
 * document head. Removes the block on unmount so SPA navigation doesn't leak
 * stale schema into the next route.
 *
 * Pass either a single JSON-LD object or an array (which will be wrapped in a
 * @graph). Pass null/undefined to skip injection (useful while data is loading).
 */
export const useJsonLd = (data) => {
  useEffect(() => {
    if (!data) return undefined;
    const payload = Array.isArray(data) ? { "@context": "https://schema.org", "@graph": data } : data;
    const head = document.head;
    let el = document.getElementById(SCRIPT_ID);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = SCRIPT_ID;
      head.appendChild(el);
    }
    el.textContent = JSON.stringify(payload);
    return () => {
      const node = document.getElementById(SCRIPT_ID);
      if (node && node.parentNode) node.parentNode.removeChild(node);
    };
  }, [data]);
};
